import React, { useState, useEffect, useRef } from 'react';
import ReactTable from 'react-table';
import Button from '../button/Button';
import Pagination from '../common/Pagination';
import 'react-table/react-table.css';
import { withRouter } from 'react-router';
import Loader from '../common/Loader';
import moment from 'moment';
import Toaster from '../common/Toaster';
import { TABLE } from '../../helper/constant';
import Api from '../../helper/Api';
import CommonModel from '../common/CommonModel';
import { compose } from 'redux';
import { connect } from 'react-redux';
import RoyTooltip from '../common/RoyTooltip';

const AdvertisementTable = (parentProps) => {
	const columns = [
		{
			Header: 'Title',
			accessor: 'title',
			className: 'text-center',
			filterable: false,
			headerClassName: 'react-table-header-class',
			Cell: (cellProps) => <div>{cellProps.original.title}</div>,
		},
		{
			Header: 'Media Type',
			accessor: 'mediaType',
			className: 'text-center',
			filterable: false,
			headerClassName: 'react-table-header-class',
			Cell: (cellProps) => <div>{cellProps.original.mediaType ? cellProps.original.mediaType.toUpperCase() : ''}</div>,
		},
		{
			Header: 'Duration',
			accessor: 'displayDuration',
			className: 'text-center',
			filterable: false,
			headerClassName: 'react-table-header-class',
			width: 100,
			Cell: (cellProps) => {
				const ad = cellProps.original;
				if (ad.mediaType && ad.mediaType.toLowerCase() === 'image') {
					return <div>{ad.displayDuration || 10}s</div>;
				} else {
					return <div>-</div>;
				}
			},
		},
		{
			Header: 'Created Date',
			accessor: 'createdAt',
			className: 'text-center',
			filterable: false,
			headerClassName: 'react-table-header-class',
			Cell: (cellProps) => {
				const createdAt = cellProps.original.createdAt;
				if (createdAt && createdAt._seconds) {
					return <div>{moment.unix(createdAt._seconds).format('MMM-DD-YYYY')}</div>;
				}
				return <div>-</div>;
			},
		},
		{
			Header: 'Status',
			accessor: 'status',
			className: 'text-center',
			headerClassName: 'react-table-header-class',
			sortable: false,
			filterable: false,
			width: 200,
			Cell: (cellProps) => (
				<div className="react-action-class">
					{cellProps.original.isActive ? (
						<div id={`active-${cellProps.original.id}`}>
							<RoyTooltip id={`act-${cellProps.original.id}`} title={'Click to Deactivate'} placement="left">
								<Button
									className="c-btn c-success mr-10"
									style={{ minWidth: '50px' }}
									onClick={() => toggleAdStatus(cellProps.original.id)}
									id={`act-${cellProps.original.id}`}
								>
									<div className="fs-14">
										<i className="fa fa-check" aria-hidden="true"></i>
									</div>
								</Button>
							</RoyTooltip>
						</div>
					) : (
						<div id={`deactive-${cellProps.original.id}`}>
							<RoyTooltip id={`dact-${cellProps.original.id}`} title={'Click to Activate'} placement="left">
								<Button
									style={{ minWidth: '50px' }}
									className="c-btn c-danger mr-10"
									onClick={() => toggleAdStatus(cellProps.original.id)}
									id={`dact-${cellProps.original.id}`}
								>
									<div>
										<div className="fs-14">
											<i className="fa fa-times" aria-hidden="true"></i>
										</div>
									</div>
								</Button>
							</RoyTooltip>
						</div>
					)}
				</div>
			),
		},
		{
			Header: 'Action',
			accessor: 'action',
			className: 'text-center',
			headerClassName: 'react-table-header-class',
			sortable: false,
			filterable: false,
			width: 400,
			Cell: (cellProps) => (
				<div className="react-action-class">
					<RoyTooltip id={`preview-${cellProps.original.id}`} title={'Preview Advertisement'} placement="left">
						<Button
							className="c-btn mr-10"
							style={{ minWidth: '50px', backgroundColor: '#6c757d', color: 'white' }}
							onClick={() => {
								setPreviewData(cellProps.original);
								setPreviewModalOpen(true);
							}}
							id={`preview-${cellProps.original.id}`}
						>
							<div className="fs-14 medium-text">
								<i className="fas fa-eye" />
							</div>
						</Button>
					</RoyTooltip>
					<RoyTooltip id={`edit-${cellProps.original.id}`} title={'Edit Advertisement'} placement="left">
						<Button
							className="c-btn c-info mr-10"
							style={{ minWidth: '50px' }}
							onClick={() => parentProps.history.push(`/advertisement/edit/${cellProps.original.id}`)}
							id={`edit-${cellProps.original.id}`}
						>
							<div className="fs-14 medium-text">
								<i className="fas fa-edit" />
							</div>
						</Button>
					</RoyTooltip>
					<RoyTooltip id={`delete-${cellProps.original.id}`} title={'Delete Advertisement'} placement="left">
						<Button
							className="c-btn c-danger mr-10"
							style={{ minWidth: '50px' }}
							onClick={() => handleDeleteAdvertisement(cellProps.original.id, cellProps.original.title)}
							id={`delete-${cellProps.original.id}`}
						>
							<div className="fs-14 medium-text">
								<i className="fas fa-trash" />
							</div>
						</Button>
					</RoyTooltip>
				</div>
			),
		},
	];

	const [tblData, settblData] = useState([]);
	const [loader, setLoader] = useState(false);
	const [pages, setPages] = useState(0);
	const [activePage, setActivePage] = useState(0);
	const [searchTitle, setSearchTitle] = useState('');
	const [field, setField] = useState('createdAt');
	const [sortBy, setSortBy] = useState('DESC');
	const [previewData, setPreviewData] = useState({});
	const [previewModalOpen, setPreviewModalOpen] = useState(false);
	const toaster = useRef();

    const handleDeleteAdvertisement = (id, title) => {
        if (window.confirm(`Are you sure you want to delete the advertisement: "${title}"?`)) {
            setLoader(true);
            Api('DELETE', `cms/advertisement/${id}`)
                .then((response) => {
                    if (response.status === 200) {
                        getList(field, sortBy, searchTitle, activePage + 1);
                        toaster.current.success('Advertisement deleted successfully');
                    } else {
                        toaster.current.error('Failed to delete advertisement');
                    }
                    setLoader(false);
                })
                .catch((error) => {
                    toaster.current.error('Error deleting advertisement: ' + (error.message || 'Unknown error'));
                    setLoader(false);
                });
        }
    };

	useEffect(() => {
		getList(field, sortBy, searchTitle, activePage + 1);
		setPages(10);
	}, []);

	const toggleAdStatus = (id) => {
		setLoader(true);
		Api('PATCH', `cms/advertisement/${id}/toggle-status`)
			.then((response) => {
				if (response.status === 200) {
					getList(field, sortBy, searchTitle, activePage + 1);
					setLoader(false);
				}
			})
			.catch((error) => {
				if (toaster.current) toaster.current.error('Failed to update status');
				setLoader(false);
			});
	};

	const onChangePageGetData = (state) => {
		if (state.page !== activePage) {
		}
	};

function getList(field = 'createdAt', sortBy = 'DESC', search = '', page = 1) {
    console.log('Fetching List with parameters:', { field, sortBy, search, page });
		setLoader(true);

		const params = {
			page: page,
			limit: TABLE.LIMIT,
			search: search.trim()
		};

		Api('GET', 'cms/advertisement', params)
			.then((res) => {
console.log('API Response Status:', res.status);
console.log('Full API Response:', JSON.stringify(res.data, null, 2));
console.log('Response Data Type:', typeof res.data);
console.log('Response Data Keys:', res.data ? Object.keys(res.data) : 'No data');
            if (res.status === 200) {
					const responseData = res.data;
console.log('Response Data Structure:', responseData);
console.log('Has data key?', responseData && responseData.hasOwnProperty('data'));
console.log('Has advertisements key in data?', responseData && responseData.data && responseData.data.hasOwnProperty('advertisements'));
if (responseData && responseData.data && responseData.data.advertisements) {
console.log('Advertisements found:', responseData.data.advertisements.length);
} else {
console.log('No advertisements in response or structure incorrect');
}
				if (responseData && responseData.data && responseData.data.advertisements) {
console.log('Advertisements Data:', responseData.data.advertisements);
console.log('First advertisement sample:', responseData.data.advertisements[0]);
if (responseData.data.advertisements[0]) {
	console.log('Sample ad keys:', Object.keys(responseData.data.advertisements[0]));
	console.log('Sample ad events/associatedEvents:', {
		events: responseData.data.advertisements[0].events,
		associatedEvents: responseData.data.advertisements[0].associatedEvents,
		eventIds: responseData.data.advertisements[0].eventIds
	});
}
                        settblData(responseData.data.advertisements);
						setPages(responseData.data.pagination ? responseData.data.pagination.totalPages : Math.ceil(responseData.data.advertisements.length / TABLE.LIMIT));
					} else {
console.log('Setting empty data - no advertisements found');
						settblData([]);
						setPages(0);
					}
					setLoader(false);
				} else {
console.log('API Response not 200:', res.status, res.data);
					setLoader(false);
					if (toaster.current) toaster.current.error(res.data.message);
				}
			})
	.catch((err) => {
			console.error('API Error:', err);
			console.error('Error response:', err.response);
			setLoader(false);
			if (toaster.current) toaster.current.error('Failed to load advertisements: ' + (err.message || 'Unknown error'));
		});
	}

console.log('Current Table Data:', tblData);
    console.log('Table Pages:', pages);
    return (
		<div>
			<div className="plr-15">
				<div className="roe-card-style mtb-15">
					<div className="roe-card-header module-header">
						<div className="flex-1 fs-16 demi-bold-text" />
						<div className="mr-10">
							<input
								value={searchTitle}
								onChange={(e) => {
									setSearchTitle(e.target.value);
									const searchValue = e.target.value;
									setLoader(true);
									setActivePage(0);
									getList(field, sortBy, searchValue, 1);
								}}
								type="text"
								placeholder="Search by Title"
								className="fs-14 medium-text plr-10 form-control react-form-input"
							/>
						</div>
						<div className="mr-10">
							<Button
								className="c-btn ma-5"
								onClick={() => parentProps.history.push('/advertisement/add')}
								style={{ backgroundColor: '#28a745', color: 'white' }}
							>
								<i className="fas fa-plus mr-10" /> Add Advertisement
							</Button>
						</div>
					</div>
					<div className="roe-card-body">
						<ReactTable
							style={{
								border: 'none',
								boxShadow: 'none',
							}}
							data={tblData}
							columns={columns}
							defaultPageSize={10}
							filterable
							minRows={2}
							manual
							defaultFilterMethod={(filter, row) => {
								const id = filter.pivotId || filter.id;
								return row[id] !== undefined
									? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
									: true;
							}}
							className="-striped -highlight custom-react-table-theme-class"
							pages={pages}
							page={activePage}
							PaginationComponent={Pagination}
							loading={loader}
							LoadingComponent={Loader}
							onFetchData={onChangePageGetData}
							onPageChange={(pageIndex) => {
								setActivePage(pageIndex);
								getList(field, sortBy, searchTitle, pageIndex + 1);
							}}
							onSortedChange={(sortProperties) => {
								const sort = sortProperties[0].desc ? 'DESC' : 'ASC';
								setSortBy(sort);
								setActivePage(0);
								setField(sortProperties[0].id);
								getList(sortProperties[0].id, sort, searchTitle, 1);
							}}
						/>
					</div>
				</div>
				{previewModalOpen && (
					<CommonModel
						modal={previewModalOpen}
						size="lg"
						title="Advertisement Preview"
						style={{ 
							maxWidth: '1000px', 
							width: '90%', 
							maxHeight: '85vh',
							overflowY: 'auto'
						}}
						children={<AdvertisementPreview data={previewData} toggle={() => setPreviewModalOpen(false)} />}
					/>
				)}
				<Toaster ref={toaster} />
			</div>
		</div>
	);
};

// Helper function to format date safely
const formatDate = (dateData) => {
  if (!dateData) return 'N/A';
  
  try {
    let date;
    
    // Handle Firestore timestamp format
    if (dateData.seconds) {
      date = new Date(dateData.seconds * 1000);
    }
    // Handle _seconds format (alternative Firestore format)
    else if (dateData._seconds) {
      date = new Date(dateData._seconds * 1000);
    }
    // Handle milliseconds timestamp
    else if (typeof dateData === 'number') {
      date = new Date(dateData);
    }
    // Handle ISO string
    else if (typeof dateData === 'string') {
      date = new Date(dateData);
    }
    // Handle Date object
    else if (dateData instanceof Date) {
      date = dateData;
    }
    else {
      return 'Invalid Date';
    }
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }
    
    return date.toLocaleDateString();
  } catch (error) {
    console.error('Error formatting date:', error, dateData);
    return 'Invalid Date';
  }
};

// Advertisement Preview Component
const AdvertisementPreview = ({ data, toggle }) => {
  return (
    <div className="advertisement-preview">
      <div className="preview-header">
        <h4 className="preview-title">
          <i className="fas fa-ad mr-2"></i> Advertisement Details
        </h4>
      </div>

      <div className="preview-content">
        <div className="details-section">
          <div className="details-info">
            <div className="field">
              <span className="label">Title: </span>
              <span className="value">{data.title || 'N/A'}</span>
            </div>
            <div className="field">
              <span className="label">Description: </span>
              <span className="value">{data.description || 'No description provided'}</span>
            </div>
            <div className="field">
              <span className="label">Media Type: </span>
              <span className="value">{data.mediaType ? data.mediaType.toUpperCase() : 'N/A'}</span>
            </div>
            <div className="field">
              <span className="label">Status: </span>
              <span className={`value ${data.isActive ? 'active' : 'inactive'}`}>{data.isActive ? 'Active' : 'Inactive'}</span>
            </div>
            <div className="field">
              <span className="label">Created Date: </span>
              <span className="value">{formatDate(data.createdAt)}</span>
            </div>
          </div>

          {data.associatedEvents && data.associatedEvents.length > 0 && (
            <div className="events-section">
              <span className="events-title">Associated Events: </span>
              <ul className="events-list">
                {data.associatedEvents.map((event, index) => (
                  <li key={index} className="event-item">
                    <i className="fas fa-calendar-check"></i> {event.eventName || `Event ${index + 1}`}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="preview-media">
          <div className="media-header">
            <h5><i className="fas fa-image mr-2"></i>Media Preview</h5>
          </div>
          {data.fileUrl ? (
            <div className="media-container">
              {data.mediaType === 'image' ? (
                <img 
                  src={data.fileUrl} 
                  alt={data.title} 
                  className="preview-image"
                  style={{
                    maxWidth: '560px',
                    maxHeight: '560px', 
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain',
                    display: 'block',
                    margin: '0 auto',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}
                />
              ) : data.mediaType === 'video' ? (
                <video 
                  controls 
                  className="preview-video"
                  style={{
                    maxWidth: '560px',
                    maxHeight: '560px', 
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain',
                    display: 'block',
                    margin: '0 auto',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}
                  src={data.fileUrl}
                >
                  <source src={data.fileUrl} type={data.mimeType} />
                  <source src={data.fileUrl} type="video/mp4" />
                  <source src={data.fileUrl} type="video/quicktime" />
                  Your browser does not support the video tag or this video format.
                  <br />Please try downloading the file to view it.
                </video>
              ) : (
                <div className="no-preview">
                  <i className="fas fa-file-alt"></i>
                  <p>Preview not available</p>
                </div>
              )}
            </div>
          ) : (
            <div className="no-media">
              <i className="fas fa-image"></i>
              <p>No media file</p>
            </div>
          )}
        </div>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn btn-primary" onClick={toggle}>
          Close
        </button>
      </div>
    </div>
  );
};

export default compose(withRouter, connect(null, null))(AdvertisementTable);

